import { useEffect } from "react";

import { useDispatch } from "react-redux";
import NewEntryStepper from "../../components/NewEntryStepper/NewEntryStepper";
import NavigationBar from "../../components/Navbar/NavigationBar";
import DataTable from "../../components/DataTable/DataTable";
import EditOrderPage from "../../containers/EditOrder/EditOrderPage";
import OrganizationSettings from "../../containers/Settings/OrganizationSettings";
// import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import SearchDialog from "../../components/SearchDialog/SearchDialog";
import { useState } from "react";
import PrintSettings from "../Content/PrintSettings";
import InvoiceCreator from "../InvoiceCreator/InvoiceCreator";
import InvoiceView from "../InvoiceView/InvoiceView";
import QuoteView from "containers/QuoteView/QuoteView";
import { useTheme } from "@emotion/react";
import UserSettingsPage from "../UserSettings/UserSettingsPage";
import ServiceCatalog from "../ServiceCatalog/ServiceCatalog";
import { fetchStatuses } from "../../store/data-table";
import InventoryPage from "containers/Inventory/InventoryPage";
import EditTransferPage from "containers/Inventory/Transfer/EditTransfer";
import { UserPermissionsContextProvider } from "contexts/UserPermissions";
import ChartsPageV2 from "containers/Charts/ChartsPage_v2";
import Settings from "containers/Settings/Settings";
import UsersSettings from "containers/Settings/UsersSettings";
import Billing from "containers/Settings/Billing";
import InvoicingModule from "./InvoicingModule";
import InvoicingPage from "./InvoicingPage";
// import TypographyTest from "pages/TypographyTest";
import { useApp } from "contexts/AppContext";

// const useStyles = makeStyles((theme) => ({
//   toolbar: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "flex-end",
//     padding: theme.spacing(0, 1),
//     // necessary for content to be below app bar
//     // ...theme.mixins.toolbar,
//   },
//   content: {
//     flexGrow: 1,
//     padding: theme.spacing(0),
//   },
// }));

const Main = (props) => {
  // const classes = useStyles();
  // const theme = useTheme();
  const [searchDialog, setSearchDialog] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const theme = useTheme();
  const { state } = useApp();

  const handleOpenSearchDialog = () => {
    setSearchDialog(true);
  };
  const handleCloseSearchDialog = () => {
    setSearchDialog(false);
  };

  useEffect(() => {
    // Set background color based on route
    const path = location.pathname;
    let bgColor = theme.palette.background.default;

    switch (path) {
      case "/":
        bgColor = theme.palette.lightBlue.main;
        break;
      case "/printSettings":
        bgColor = theme.palette.background.paper;
        break;
      default:
        bgColor = theme.palette.background.paper;
        break;
    }

    document.body.style.backgroundColor = bgColor;
  }, [
    location.pathname,
    theme.palette.background.default,
    theme.palette.lightBlue.main,
    document.body.style.backgroundColor,
  ]);

  useEffect(() => {
    //Get statuses
    dispatch(fetchStatuses());
  }, [dispatch]);

  // document.body.style.backgroundColor = "black";
  const searchFieldsBucket = [
    "id",
    "malfunction",
    "device",
    "customer",
    "note",
    "resolution",
    "imei",
  ];
  const [searchInFields, setSearchInFields] = useState([
    "id",
    "malfunction",
    "device",
    "customer",
    "note",
    "resolution",
    "imei",
  ]);

  return (
    <>
      <UserPermissionsContextProvider>
        <NavigationBar openSearchDialog={handleOpenSearchDialog}>
          <SearchDialog
            open={searchDialog}
            handleClose={handleCloseSearchDialog}
          />
          {/* <main > */}
          <Routes>
            <Route
              path="/repairs"
              element={
                <DataTable
                  searchFieldsBucket={searchFieldsBucket}
                  searchInFields={searchInFields}
                  setSearchInFields={setSearchInFields}
                />
              }
            />
            <Route
              path="/editEntry/:repairOrderId"
              element={<EditOrderPage token={props.token} />}
            />
            <Route path="/viewInvoices/" element={<InvoiceView />} />
            <Route path="/quotes/" element={<QuoteView />} />
            <Route path="/service-catalog" element={<ServiceCatalog />} />
            <Route
              path="/editEntry/request/:tempEntryId"
              element={<EditOrderPage />}
            />
            <Route path="/invoiceCreator" element={<InvoiceCreator />} />
            <Route
              path="/printSettings"
              element={
                state.isOwner ? (
                  <PrintSettings />
                ) : (
                  <Navigate to="/repairs" replace />
                )
              }
            />
            {/* Lock charts to owners only */}
            <Route
              path="/charts"
              element={
                state.isOwner ? (
                  <ChartsPageV2 />
                ) : (
                  <Navigate to="/repairs" replace />
                )
              }
            />
            <Route path="/userSettings" element={<UserSettingsPage />} />
            <Route path="/inventory" element={<InventoryPage />} />
            {/* Lock organization settings, users, billing to owners only */}
            <Route
              path="/settings/organization"
              element={
                state.isOwner ? (
                  <OrganizationSettings />
                ) : (
                  <Navigate to="/repairs" replace />
                )
              }
            />
            <Route
              path="/settings/users"
              element={
                state.isOwner ? (
                  <UsersSettings />
                ) : (
                  <Navigate to="/repairs" replace />
                )
              }
            />
            <Route
              path="/settings/billing"
              element={
                state.isOwner ? <Billing /> : <Navigate to="/repairs" replace />
              }
            />
            {/* <Route path="/invoicing/module" element={<InvoicingPage />} /> */}
            <Route
              path="/inventory/transfer/:transferId"
              element={<EditTransferPage />}
            />
            {/* Lock Settings route to owners only */}
            <Route
              path="/settings"
              element={
                state.isOwner ? (
                  <Settings />
                ) : (
                  <Navigate to="/repairs" replace />
                )
              }
            />
            <Route path="*" element={<Navigate to="/repairs" replace />} />
          </Routes>
          {/* </main> */}
        </NavigationBar>

        <NewEntryStepper />
        {props.children}
      </UserPermissionsContextProvider>
    </>
  );
};

export default Main;
